import getActions from "./actionsPopupUtils";

const employer_pocs_actions = (formName, isSubaccount) => {
  return getActions({ formName, isSubaccount, shared: true });
};

export default employer_pocs_actions;
